import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function Disclaimer() {
  return (
    <PolicyPage title="Website & Product Disclaimer">
      <h2>General information</h2>
      <p>Website articles, FAQs, product-care suggestions, recipes, and storage guidance are general information. They are not medical, nutritional, food-safety, legal, financial, or other professional advice.</p>

      <h2>Product suitability</h2>
      <p>You are responsible for checking dimensions, materials, capacity, compatibility, allergies, and intended use before purchase. Follow the current product label and manufacturer instructions if they differ from general website content.</p>

      <h2>Food storage</h2>
      <p>A storage product cannot make unsafe food safe or guarantee a particular shelf life. Safety depends on the food, initial condition, preparation, time, temperature, sanitation, and individual health circumstances. When in doubt, discard the food and consult authoritative local guidance.</p>

      <h2>Images, colors, and natural variation</h2>
      <p>Images are illustrative. Screen settings, lighting, and production batches can affect color. Natural and handmade materials may vary in texture, grain, glaze, shade, and small dimensions without being defective.</p>

      <h2>Availability and external information</h2>
      <p>We do not guarantee continuous site availability or that every historical statement remains current. Links or references to independent services are provided for convenience and do not make us responsible for their content or availability.</p>

      <h2>Mandatory rights</h2>
      <p>Nothing in this disclaimer excludes a warranty, duty, or liability that applicable law does not allow us to exclude.</p>

      <h2>Questions</h2>
      <p>For product-specific information before purchase, email <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default Disclaimer;
